export default __webpack_public_path__ + "static/media/bg_tablet_family.f1002788.jpg";